<template>
    <div class="three-review-area ptb-100">
        <div class="container">
            <div class="three-review-slider">
            <carousel 
                :autoplay="5000"
                :wrap-around="true"
            >
                <slide v-for="slide in carouselItems" :key="slide.id">
                    <div class="review-item">
                        <i class='bx bxs-quote-left'></i>
                        <h2>{{slide.shortDesc}}</h2>
                        <div class="review-bottom">
                            <img :src="slide.image" alt="Review">
                            <h3>{{slide.name}}</h3>
                            <span>{{slide.position}}</span>
                        </div>
                    </div>
                </slide>

                <template #addons>
                    <Pagination  />
                </template>
            </carousel>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Pagination , Slide, } from 'vue3-carousel';

export default {
    name: 'Review',
    components: {
        Carousel,
        Slide,
        Pagination 
    },
    data() {
        return {
            carouselItems: [
                {
                    id: 1,
                    shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod te iidunt ut labore et dolore odit aut fugit sed quia dolores eos qui ratione vluptatem sequi nidunt ut labore et dolore magnam aliquam',
                    name: 'JAMES TAYLOR',
                    position: 'Policy Advisor',

                },
                {
                    id: 2,
                    shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod te iidunt ut labore et dolore odit aut fugit sed quia dolores eos qui ratione vluptatem sequi nidunt ut labore et dolore magnam aliquam',
                    name: 'JAMES TAYLOR',
                    position: 'Policy Advisor',

                },
                {
                    id: 3,
                    shortDesc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod te iidunt ut labore et dolore odit aut fugit sed quia dolores eos qui ratione vluptatem sequi nidunt ut labore et dolore magnam aliquam',
                    name: 'JAMES TAYLOR',
                    position: 'Policy Advisor',

                },
            ],
            personDetails: {
                purchasePrice: '$7000', 
                estimatedMonthly: '$250',
                downPayment: '$800',
                zipCode: '73848',
                emailAddress: 'john@gmail.com',
                createdAt: new Date()
            },
        }
    },
}
</script>